import {Injectable} from '@angular/core';
import {CanMatch, Route, UrlSegment} from '@angular/router';
// import {AccessControlService} from '../access-control/access-control.service';
import Keycloak from 'keycloak-js';
// import {UserService} from "../api/user.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanMatch {

  constructor(
    private keycloak: Keycloak,
    // private _accessControl: AccessControlService,
  ) {}

  public async canMatch(route: Route, segments: UrlSegment[]): Promise<boolean> {
    if (!this.keycloak.authenticated) {
      await this.keycloak.login();
      return false;
    }

    return true;
  }
}
